import { Component, Input, OnChanges } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { ChangeDetectorRef } from "@angular/core";

import { RequestForm } from "../../../../partials/form-state/form-state.component";

@Component({
	selector: "user-employer",
	templateUrl: "./user-employer.component.html",
})
export class UserEmployerComponent implements OnChanges {
	@Input() user: any;

	companies: any[] = [];

	employeeIdForm = new RequestForm(
		true,
		new UntypedFormGroup({
			employeeId: new UntypedFormControl(""),
		})
	);

	employerForm = new RequestForm(
		true,
		new UntypedFormGroup({
			employerId: new UntypedFormControl(""),
		})
	);

	constructor(private http: HttpClient, private change: ChangeDetectorRef) {
		this.http.get("/api/companies").subscribe(
			(companies: any[]) => {
				this.companies = companies;
				this.change.detectChanges();
			},
			(error) => console.error("Failed to load companies:", error)
		);
	}

	ngOnChanges() {
		if (this.user) {
			this.employeeIdForm.controls.setValue({
				employeeId: this.user.employeeID || "",
			});
			this.employerForm.controls.setValue({
				employerId: this.user.employer?.id || "",
			});
		}
	}

	setEmployeeId() {
		if (this.employeeIdForm.working) return;
		this.employeeIdForm.setWorking();
		this.http
			.put(`/api/users/${this.user.id}/employeeId`, {
				employeeId: this.employeeIdForm.getValue().employeeId || null,
			})
			.subscribe(
				() => {
					this.user.employeeID =
						this.employeeIdForm.getValue().employeeId || null;
					this.employeeIdForm.setSuccess("Anställningsnummer uppdaterat");
				},
				(error) => this.employeeIdForm.setError("Fel: " + error.error)
			)
			.add(() => this.change.detectChanges());
	}

	setEmployer() {
		if (this.employerForm.working) return;
		this.employerForm.setWorking();
		const employerId = this.employerForm.getValue().employerId || null;
		this.http
			.put(`/api/users/${this.user.id}/employer`, { employerId })
			.subscribe(
				() => {
					this.user.employer = employerId
						? this.companies.find((c) => c.id == employerId)
						: null;
					this.employerForm.setSuccess("Arbetsgivare uppdaterad");
				},
				(error) => this.employerForm.setError("Fel: " + error.error)
			)
			.add(() => this.change.detectChanges());
	}
}
